import { render, staticRenderFns } from "./common-domain.vue?vue&type=template&id=6b9224ea&scoped=true"
import script from "./common-domain.vue?vue&type=script&lang=js"
export * from "./common-domain.vue?vue&type=script&lang=js"
import style0 from "./common-domain.vue?vue&type=style&index=0&id=6b9224ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0_supports-color@6.1.0___css-loader@_035c03662a22344aa556e5f10fe24304/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9224ea",
  null
  
)

export default component.exports